import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { fetchAuth, setFiresotreUser } from "../actions";
import * as API from "../api/api";
import firebase from "firebase";
import { userState } from "./user";

export const brandState = atom({
  key: "brandState",
  default: undefined,
});

export const useSetBrand = () => {
  const user = useRecoilValue(userState);
  const setBrand = useSetRecoilState(brandState);
  const managingBrandId = useMemo(
    () => user?.firestoreUser?.managingBrandId,
    [user]
  );
  useEffect(() => {
    (async () => {
      if (managingBrandId) {
        const brand = await firebase
          .firestore()
          .collection("brand")
          .doc(managingBrandId)
          .get()
          .then((doc) => ({ id: doc.id, ...doc.data() }));
        setBrand(brand);
      }
    })();
  }, [managingBrandId]);
};
